<template>
  <div class="splash">
    <div class="splash-container generator-wrapper">
      <div class="generator"
           v-for="generator in generators"
           :key="generator.name"
      >
        <div class="name" v-html="generator.name"></div>
        <figure>
          <img :src="getImage(generator.image, false)" alt="" v-if="generator.image">
        </figure>
        <router-link v-if="generator.enabled" :to="{name: generator.route}" tag="a" class="btn btn-primary">
          Aan de slag
        </router-link>
        <div v-else class="soon">
          {{ $t('splash.availableSoon') }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import PowerpackGenerator from './../../src/assets/mini_powerpack.png';
import CilinderGenerator from './../../src/assets/cilinder-generator.jpg';
import MotorGenerator from './../../src/assets/motor-generator.jpg';
import TubesGenerator from './../../src/assets/tubes-generator.jpg';

export default {
  name: 'Splash',
  data() {
    return {

    };
  },
  computed: {
    generators() {
      return [
        {
          name: this.$t('splash.powerpackGenerator'),
          route: 'powerpack-motor-configurator',
          image: PowerpackGenerator,
          enabled: true,
        },
        {
          name: this.$t('splash.cylinderGenerator'),
          route: 'cilinder-configurator',
          image: CilinderGenerator,
          enabled: true,
        },
        {
          name: this.$t('splash.hoseGenerator'),
          route: 'slang-configurator',
          image: TubesGenerator,
          enabled: true,
        },
        {
          name: this.$t('splash.motorGenerator'),
          route: 'motor-configurator',
          image: MotorGenerator,
          enabled: true,
        },
      ];
    },
  },
  methods: {

  },
};
</script>

<style lang="scss">
.splash {
  box-sizing: border-box;
  padding-top: 150px;
  padding-bottom: 100px;
  background: #fff;

  @media only screen and (min-width: 768px) {
    height: 100vh;
    display: flex;
    flex-direction: column;
    justify-content: center;
  }

  .splash-container {
    max-width: 1430px;
    margin: 0 auto;
    padding: 0 16px;
  }

  .generator-wrapper {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    width: 100%;

    @media only screen and (min-width: 768px) {
      grid-template-columns: repeat(4, 1fr);
    }

    .generator {
      display: flex;
      flex-direction: column;
      justify-content: center;
      padding: 24px;
      align-items: center;
      transition: all ease 0.3s;

      &:hover {
        transform: scale(1.1);
      }

      .name {
        font-weight: bold;
        font-size: 20px;
        height: 60px;
        text-align: center;
        display: flex;
        align-items: center;
        justify-content: center;
      }

      figure {
        width: 100%;
        height: 0;
        padding-bottom: 80%;
        position: relative;

        img {
          position: absolute;
          top: 0;
          right: 0;
          bottom: 0;
          left: 0;
          width: 100%;
          height: 100%;
          object-position: center;
          object-fit: contain;
        }
      }

      .soon {
        font-style: italic;
        opacity: 0.8;
        height: 38px;
        display: flex;
        justify-content: center;
        align-items: center;
        text-align: center;
      }
    }
  }
}
</style>
